var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styledWithTheme } from '../../style/theme';
export var LoadingStaticGradient = styledWithTheme.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: linear-gradient(90deg, ", ", transparent);\n    border-radius: ", "\n    opacity: 0.5;\n\n    width: 10rem;\n    height: 2rem;\n"], ["\n    background: linear-gradient(90deg, ",
    ", transparent);\n    border-radius: ", "\n    opacity: 0.5;\n\n    width: 10rem;\n    height: 2rem;\n"])), function (p) {
    return p.brandColor ? p.theme.palette.brandColor : p.color || 'white';
}, function (p) { return p.theme.radius.small; });
var templateObject_1;
//# sourceMappingURL=loading-static-gradient.js.map